var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ButtonDefault',{staticClass:"black-text",attrs:{"callback":_vm.callback,"green":true,"loading":_vm.loading,"type":'submit',"block":true}},[_vm._v(" Acessar ")])}
var staticRenderFns = []

export { render, staticRenderFns }